import { EVENTS } from "@/data/content";
import { BOOKING_URL } from "@/data/content";
import { Calendar, MapPin, Clock } from "lucide-react";
import { SP_WIDGET_ATTRS } from "./BookingButton";

export default function Events() {
  return (
    <section id="events" className="py-28 lg:py-36" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4">05 · Events & Workshops</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight">
              Come gather. The body co-regulates in <em className="italic">good company</em>.
            </h2>
          </div>
        </div>

        <div className="border-t" style={{ borderColor: "var(--sano-border)" }}>
          {EVENTS.map((e, i) => (
            <div
              key={i}
              className="grid lg:grid-cols-12 gap-6 py-10 border-b items-start group hover:bg-[#F0EBE1] transition-colors px-2 lg:px-4"
              style={{ borderColor: "var(--sano-border)" }}
              data-testid={`event-${i}`}
            >
              <div className="lg:col-span-2 flex items-center gap-2 text-sm font-medium" style={{ color: "var(--sano-olive)" }}>
                <Calendar size={14} strokeWidth={1.5} />
                {e.date}
              </div>
              <div className="lg:col-span-5">
                <h3 className="font-serif-display text-2xl leading-snug mb-2">{e.title}</h3>
                <p className="text-sm leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
                  {e.blurb}
                </p>
              </div>
              <div className="lg:col-span-3 text-sm space-y-1.5" style={{ color: "var(--sano-ink-2)" }}>
                <div className="flex items-center gap-2"><Clock size={14} strokeWidth={1.5} />{e.time}</div>
                <div className="flex items-center gap-2"><MapPin size={14} strokeWidth={1.5} />{e.location}</div>
              </div>
              <div className="lg:col-span-2 lg:text-right">
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noreferrer"
                  {...SP_WIDGET_ATTRS}
                  className="inline-block text-sm border-b border-current pb-0.5 hover:opacity-70"
                  style={{ color: "var(--sano-olive)" }}
                  data-testid={`event-reserve-${i}`}
                >
                  Reserve seat →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
